export interface INavigationRoute {
  name: string
  displayName: string
  role: number[]
  meta: { icon: string }
  children?: INavigationRoute[]
}

export default {
  root: {
    name: '/',
    displayName: 'navigationRoutes.home',
  },
  routes: [
    {
      name: 'faq',
      displayName: 'menu.faq',
      role: [0, 1],
      meta: {
        icon: 'fa-circle-question',
      },
    },
    {
      name: 'files',
      displayName: 'menu.files',
      role: [1],
      meta: {
        icon: 'fa-file-export',
      },
    },
    {
      name: 'users',
      displayName: 'menu.users',
      role: [1],
      meta: {
        icon: 'fa-users',
      },
    },
    {
      name: 'checking',
      displayName: 'menu.checking',
      role: [1, 2],
      meta: {
        icon: 'fa-flag-checkered',
      },
    },
    {
      name: 'statistics',
      displayName: 'menu.statistics',
      role: [1],
      meta: {
        icon: 'fa-tasks',
      },
    },
    {
      name: 'monmanagement',
      displayName: 'menu.monmanagement',
      role: [1],
      meta: {
        icon: 'fa-desktop',
      },
    },
    {
      name: 'pages',
      displayName: 'menu.pages',
      role: [0, 1],
      meta: {
        icon: 'fa-pen-to-square',
      },
      disabled: true,
      children: [
        {
          name: 'form_1',
          displayName: 'menu.form_1',
        },
        {
          name: 'form_2',
          displayName: 'menu.form_2',
        },
        {
          name: 'form_22',
          displayName: 'menu.form_22',
        },
        {
          name: 'form_23',
          displayName: 'menu.form_23',
        },
        {
          name: 'form_24',
          displayName: 'menu.form_24',
        },
        {
          name: 'form_3',
          displayName: 'menu.form_3',
        },
        {
          name: 'form_4',
          displayName: 'menu.form_4',
        },
        {
          name: 'form_5',
          displayName: 'menu.form_5',
        },
        {
          name: 'form_6',
          displayName: 'menu.form_6',
        },
        {
          name: 'form_71',
          displayName: 'menu.form_71',
        },
        {
          name: 'form_72',
          displayName: 'menu.form_72',
        },
        {
          name: 'form_73',
          displayName: 'menu.form_73',
        },
        {
          name: 'form_74',
          displayName: 'menu.form_74',
        },
        {
          name: 'form_75',
          displayName: 'menu.form_75',
        },
        {
          name: 'form_81',
          displayName: 'menu.form_81',
        },
        {
          name: 'form_82',
          displayName: 'menu.form_82',
        },
        {
          name: 'form_83',
          displayName: 'menu.form_83',
        },
        {
          name: 'form_9',
          displayName: 'menu.form_9',
        },
        {
          name: 'form_1011',
          displayName: 'menu.form_1011',
        },
        {
          name: 'form_1012',
          displayName: 'menu.form_1012',
        },
        {
          name: 'form_102',
          displayName: 'menu.form_102',
        },
        {
          name: 'form_1031',
          displayName: 'menu.form_1031',
        },
        {
          name: 'form_1032',
          displayName: 'menu.form_1032',
        },
        {
          name: 'form_104',
          displayName: 'menu.form_104',
        },
        {
          name: 'form_105',
          displayName: 'menu.form_105',
        },
        {
          name: 'form_106',
          displayName: 'menu.form_106',
        },
        {
          name: 'form_107',
          displayName: 'menu.form_107',
        },
        {
          name: 'form_108',
          displayName: 'menu.form_108',
        },
        {
          name: 'form_111',
          displayName: 'menu.form_111',
        },
        {
          name: 'form_112',
          displayName: 'menu.form_112',
        },
        {
          name: 'form_121',
          displayName: 'menu.form_121',
        },
        {
          name: 'form_122',
          displayName: 'menu.form_122',
        },
        {
          name: 'form_123',
          displayName: 'menu.form_123',
        },
        {
          name: 'form_124',
          displayName: 'menu.form_124',
        },
        {
          name: 'form_125',
          displayName: 'menu.form_125',
        },
        {
          name: 'form_126',
          displayName: 'menu.form_126',
        },
        {
          name: 'form_127',
          displayName: 'menu.form_127',
        },
        {
          name: 'form_128',
          displayName: 'menu.form_128',
        },
        {
          name: 'form_129',
          displayName: 'menu.form_129',
        },
        {
          name: 'form_1210',
          displayName: 'menu.form_1210',
        },
        {
          name: 'form_1211',
          displayName: 'menu.form_1211',
        },
        {
          name: 'form_1212',
          displayName: 'menu.form_1212',
        },
        {
          name: 'form_131',
          displayName: 'menu.form_131',
        },
        {
          name: 'form_132',
          displayName: 'menu.form_132',
        },
        {
          name: 'form_133',
          displayName: 'menu.form_133',
        },
        {
          name: 'form_134',
          displayName: 'menu.form_134',
        },
        {
          name: 'form_135',
          displayName: 'menu.form_135',
        },
        {
          name: 'form_141',
          displayName: 'menu.form_141',
        },
        {
          name: 'form_142',
          displayName: 'menu.form_142',
        },
        {
          name: 'form_151',
          displayName: 'menu.form_151',
        },
        {
          name: 'form_152',
          displayName: 'menu.form_152',
        },
        {
          name: 'form_153',
          displayName: 'menu.form_153',
        },
        {
          name: 'form_154',
          displayName: 'menu.form_154',
        },
        {
          name: 'form_161',
          displayName: 'menu.form_161',
        },
        {
          name: 'form_162',
          displayName: 'menu.form_162',
        },
        {
          name: 'form_171',
          displayName: 'menu.form_171',
        },
        {
          name: 'form_172',
          displayName: 'menu.form_172',
        },
        {
          name: 'result',
          displayName: 'menu.result',
          role: [1],
          meta: {
            icon: 'fa-flag-checkered',
          },
        },
      ],
    },
  ] as INavigationRoute[],
}
